import appBus from "../../views/appFleet/bus.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("bus", {
    url: "bus/:id",
    parent: "app",
    views: {
      view: {
        template: appBus,
      },
    },
    data: { title: "Bus" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bus/bus.urls.js